import { render, staticRenderFns } from "./gobierno.vue?vue&type=template&id=3c0af2b7&scoped=true&"
import script from "./gobierno.vue?vue&type=script&lang=ts&"
export * from "./gobierno.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0af2b7",
  null
  
)

export default component.exports